<!-- eslint-disable no-undef -->
<script setup lang="ts">
defineEmits<{
  click: [];
}>();
</script>

<template>
  <button class="brand-icon-button" @click="$emit('click')">
    <span class="brand-icon-button__icon">
      <slot name="icon"></slot>
    </span>
    <span class="brand-icon-button__text">
      <slot></slot>
    </span>
  </button>
</template>

<style lang="scss" scoped>
// ===== Design tokens =====
$spacing-1: 4px;
$spacing-2: 8px;
$spacing-3: 12px;
$spacing-4: 16px;
$spacing-5: 20px;

$radius-2: 8px;

$color-gold: #ffc36e;
$color-gold-hover: #ffb347;
$color-gold-text: #fff;
$color-gold-text-icon: #d49a3d;
$color-gold-text-on: #2d2d2d;
$color-gold-bg: transparent;
$color-gold-bg-hover: rgba($color-gold, 0.25);
$color-gold-border: rgba($color-gold, 0.6);

$font-size-md: 12px;
$line-height-md: 16px;
$min-height-md: 28px;
$icon-size-md: 33px;

// ===== Button base =====
.brand-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border: 1px solid $color-gold-border;
  border-radius: $radius-2;
  background-color: $color-gold-bg;
  color: $color-gold-text;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  height: 40px;
  padding-top: 0;
  padding-bottom: 0;
  min-width: 160px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

// ===== Selected state (replaces hover) =====
.brand-icon-button--selected {
  background-color: $color-gold-bg-hover;
  border-color: $color-gold;
}

// ===== Icon =====
.brand-icon-button__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: $color-gold-text-icon;
  width: $icon-size-md;
  height: $icon-size-md;
  flex-shrink: 0;
  margin-right: 9px;

  ::v-deep svg {
    width: $icon-size-md;
    height: $icon-size-md;
  }
}

// ===== Text =====
.brand-icon-button__text {
  line-height: inherit;
  // font-weight: 500;
}
</style>
